<template>
  <div class="ent_statement">
    <router-link to="/">返回</router-link>
    <h2 class="blue_title">企业信息主体声明须知</h2>
    <p class="content-text-indent">根据《金融信用信息基础数据库企业征信异议处理业务规程》异议处理结束后，企业仍需要对异议信息进行说明的，可以向征信中心、各地征信分中心提出添加信息主体声明的申请。</p>
    <span class="blue_span">一、企业信息主体声明申请流程：</span>
    <div>
      <p class="content-text-indent">填表→微信预约→出示预约信息→提交材料→审核是否受理；不受理的，予以退回并告知不予接收的原因。</p>
    </div>
    <span class="blue_span">二、企业申请信息主体声明提交材料顺序如下：（用A4纸规格，除申请表外，其他资料必须加盖单位公章）</span>
    <div>
      <p class="content-text-indent">1、填写《企业信息主体声明申请表》（见附件1）；</p>
      <p class="content-text-indent">2、签领《企业征信异议回复函》的原件及复印件（见附件2）；</p>
      <p class="content-text-indent">3、有效执照/注册登记证（统一社会信用代码）证件原件及复印件；（见特别提示3）<b class="red">（温馨提示：为预防企业查询信息定位出错，建议提供信用机构代码证号供查验，如不能提 供，系统可能会出现借款人不存在或空白，无法正常查询）</b></p>
      <p class="content-text-indent">4、企业法定代表人申请添加企业信息主体声明的，需提供法人有效身份证件原件及复印件；</p>
      <p class="content-text-indent">5、企业法定代表人委托经办人申请企业信息主体声明须填写《企业主体信息声明授权委托书》原件（见附件3），并提供经办人有效身份证件原件及复印件。<b class="red">（温馨提示：授权委托书须法人亲笔签字）</b></p>
      <p class="content-text-indent">6、出示企业信用报告。</p>
    </div>
    <span class="blue_span">三、受理时间：</span>
    <div>
      <p class="content-text-indent">星期一至星期五（国家规定节假日除外）</p>
      <p class="content-text-indent">上午：8：30--11：30，下午：14：00--17：00</p>
    </div>
    <span class="red_span">特别提示：</span>
    <div>
      <p class="content-text-indent">1、声明仅限针对信用报告内容有异议的部分提出，可由征信分中心接收材料，由征信中心审核是否受理；</p>
      <p class="content-text-indent">2、复印件中的文字及图案要求清晰不能有遮挡（包括公章的遮挡）；</p>
      <p class="content-text-indent">3、企业有效证件包括：营业执照、事业单位法人证书、社会团体法人登记证书等登记管理部门颁发的合法证照；</p>
      <p class="content-text-indent">4、有效身份证件包括：中国公民的居民身份证，军人的军官证、士兵证，港澳台人士的通行证，外籍人士的护照（外籍人士护照须提交领事馆或公证处的翻译证明文件原件及复印件）。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntStatement.vue'
}
</script>

<style scoped>
.ent_statement {
  padding: 20px;
}

.blue_title {
  text-align: center;
  font-size: 20px;
  font-weight: normal;
  color: #3b88d6;
}

.blue_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #3b88d6;
}

.red_span {
  margin-top: 20px;
  font-size: 14px;
  line-height: 30px;
  color: #f00;
}

.content-text-indent {
  text-indent: 2em;
  font-size: 12px;
  margin: 0;
  color: #999;
  line-height: 24px;
}

.red {
  color: #f00;
  font-weight: 400;
}
</style>
